<div class="menu-list">
  <h4 *ngIf="title" class="menu-list__title px-xl text-secondary">{{ title }}</h4>

  <ul class="menu-list__nav">
    <ng-content></ng-content>
  </ul>
</div>
